var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "250px",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-seeklogo.com",
    transform: "translate(10.000000, 32.000000)",
    fill: "#55ACEE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230,22.126742 C221.537474,25.8797323 212.44314,28.4162186 202.897875,29.5570065 C212.640843,23.7167782 220.122425,14.4693296 223.645744,3.45096748 C214.528695,8.85793187 204.429862,12.7850689 193.681554,14.9017521 C185.073485,5.73086068 172.810015,-2.493665e-15 159.238341,-2.493665e-15 C133.177731,-2.493665e-15 112.0496,21.1272907 112.0496,47.1862175 C112.0496,50.8845239 112.46772,54.4860822 113.271992,57.9395735 C74.0544643,55.9717985 39.2848312,37.1858151 16.0114123,8.63751416 C11.949669,15.6067522 9.62266363,23.7125718 9.62266363,32.3601814 C9.62266363,48.7308241 17.9539486,63.1740737 30.6153481,71.6357584 C22.8796957,71.3909433 15.6042284,69.2683712 9.24155965,65.7341161 C9.23819455,65.9309778 9.23819455,66.1286806 9.23819455,66.3272248 C9.23819455,89.1900945 25.5036761,108.262117 47.0903105,112.596437 C43.1303632,113.67497 38.9617762,114.251253 34.6577417,114.251253 C31.6173232,114.251253 28.6610337,113.95596 25.7804601,113.404916 C31.7847398,132.152201 49.2112001,145.794543 69.8597973,146.175646 C53.7104137,158.831157 33.3638392,166.374996 11.2564468,166.374996 C7.44793152,166.374996 3.69157613,166.152054 0,165.716266 C20.8824756,179.104539 45.6861992,186.915908 72.3340283,186.915908 C159.128132,186.915908 206.590292,115.01346 206.590292,52.6579611 C206.590292,50.6119463 206.544862,48.5768683 206.454003,46.5535681 C215.672848,39.9006547 223.673507,31.5895607 230,22.126742",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.4b7ed7b6ab08698bf6232c5ca6047a99.svg";
export { ForwardRef as ReactComponent };